export default {
  onboarding: {
    welcome: {
      title: "Bem-vindo ao",
      subtitle: "Seu app de referência para pesquisa de apostas esportivas em props, parlays e principais tendências. Hora de subir de nível.",
      headline: "Encontre sua próxima aposta",
      secondaryCta: "Já tem uma conta? Entrar",
    },
    leagues: {
      title: "Escolha suas ligas favoritas",
      subtitle: "Veja primeiro as ligas que importam para você sempre que abrir o app.",
    },
    location: {
      title: "Veja o que está disponível perto de você",
      subtitle: "Ative a localização para ver quais operadores e ofertas estão disponíveis na sua região.",
      allowLocationSharing: "Permitir compartilhamento de localização",
      orSelectRegion: "ou selecione sua região",
    },
    providers: {
      title: "Escolha seus operadores",
      subtitle: "Escolha seus operadores para tendências e odds personalizadas e uma experiência de betslip mais fluida.",
      emptyCta: "Ainda não tenho um",
    },
    odds: {
      title: "Escolha o formato das odds",
      subtitle: "Veja as odds no formato com que você se sente mais confortável para decidir com mais rapidez e facilidade.",
    },
    socialProof: {
      title: "Confiado por apostadores em todos os lugares",
      subtitle: "De usuários iniciantes a apostadores diários, o Linemate entrega insights mais inteligentes em escala",
      reviewer: "Avaliador da App Store",
      reviews: {
        review1: {
          title: "Sinceramente, o app mais bem desenhado que encontrei há tempos.",
          text: "Tudo está exatamente onde precisa estar, as funções de cada seleção funcionam como esperado, um app muito bem elaborado, cheio de informação, mas ainda assim eficiente e organizado. Como fã de estatísticas, dou os parabéns ao Linemate pelo design e pela facilidade de encontrar boas oportunidades."
        },
        review2: {
          title: "Melhor app de todos",
          text: "Este é 100% o melhor app para apostas esportivas... depois de testar por alguns dias, fiquei convencido. Recomendo muito a versão paga para aproveitar tudo o que ele oferece. Você não vai se decepcionar! Baixe com confiança e aproveite!"
        },
        review3: {
          title: "O melhor",
          text: "Já testei muitos apps de estatísticas. O Linemate é o app ao qual eu sempre volto. Eles oferecem muito de graça, continuam adicionando recursos sem tirar nada, e o plano Plus vale muito o preço. O suporte respondeu em 5 minutos. Eles claramente se importam em ser o app de referência. Recomendo muito."
        },
        review4: {
          title: "Surpreendentemente bom",
          text: "Se você é novo e segue props cegamente, os resultados vão variar; ainda é preciso estratégia. Baixei o Linemate depois que meus parlays perdiam por margens pequenas, e meu primeiro parlay de 7 legs em props de jogador bateu. Por US$10/mês, com a primeira semana grátis, vale muito a pena. Não é perfeito, mas faz a maior parte do trabalho pesado."
        },
        review5: {
          title: "Ótimo app!",
          text: "Nenhum app de apostas é 100%, mas este trouxe os melhores resultados para mim até agora. É tudo baseado em estatísticas e dados reais. A versão grátis é sólida, e a assinatura é ainda melhor; dá para recuperar facilmente o valor com este app."
        },
        review6: {
          title: "Ótimo app que se destaca",
          text: "Ótimo app que realmente se destaca, acessível e com recursos fortes para pesquisa. No geral, trabalho incrível, continuem assim."
        },
      },
    },
    summary: {
      title: "Seu perfil está pronto",
      subtitle: "Personalizamos o app com base nas suas escolhas. Crie seu perfil para salvar e começar.",
      leagues: "Suas ligas",
      location: "Sua localização",
      oddsFormat: "Seu formato de odds",
      operators: "Seus operadores",
      noOperators: "Nenhum operador",
    },
    consent: {
      title: "Fique por dentro",
      subtitle: "Receba novidades sobre recursos, melhorias e ofertas. Cancele quando quiser.",
      emailToggle: "Receber novidades e ofertas exclusivas por e-mail",
      pushToggle: "Ativar notificações para insights em tempo real",
      confirm: "Confirmar minhas escolhas",
    },
  },
};